export const FOLDER_ROUTES = {
  'impositivo-arca': { titulo: 'ARCA', startPath: ['01 - Impositivo', '00 - Arca'] },
  'impositivo-dpr': { titulo: 'DPR', startPath: ['01 - Impositivo', '01 - Dpr'] },
  'impositivo-municipalidad': { titulo: 'Municipalidad', startPath: ['01 - Impositivo', '02 - Municipalidad'] },
  'rh-legajos': { titulo: 'Legajos', startPath: ['02 - Recursos Humanos', '00 - Legajos'] },
  'rh-recibos': { titulo: 'Recibos de Sueldos', startPath: ['02 - Recursos Humanos', '01 - Recibos'] },
  'rh-libro': { titulo: 'Libro de Sueldos', startPath: ['02 - Recursos Humanos', '02 - Libro De Sueldos'] },
  'rh-sindicatos': { titulo: 'Sindicatos', startPath: ['02 - Recursos Humanos', '03 - Sindicatos'] },
  'rh-art': { titulo: 'Documentacion ART', startPath: ['02 - Recursos Humanos', '04 - Documentacion Art'] },
  'rh-empadronamiento': { titulo: 'Empadronamiento', startPath: ['06 - Recursos Humanos', '00 - Empadronamiento'] },
  'g1-doc-social': { titulo: 'Documentacion Social', startPath: ['00 - Documentacion Social'] },
  'g1-doc-socio': { titulo: 'Documentacion Socio Gerente', startPath: ['01 - Documentacion Socio Gerente'] },
  'g1-libro-actas': { titulo: 'Libro de Actas', startPath: ['02 - Libro De Actas'] },
  'g1-libro-inventario': { titulo: 'Libro de Inventario y Balance', startPath: ['03 - Libro De Inventario Y Balance'] },
  'g1-libro-diario': { titulo: 'Libro Diario', startPath: ['04 - Libro Diario'] },
  'g1-doc-financiera': { titulo: 'Doc. Financiera - Bancos - Billeteras', startPath: ['07 - Doc. Financiera - Bancos - Billeteras'] },
  'g1-informes': { titulo: 'Informes', startPath: ['08 - Informes'] },
  'g1-proveedor': { titulo: 'Proveedor del Estado', startPath: ['09 - Proveedor Del Estado'] },
  'g2-doc-personal': { titulo: 'Documentacion Personal', startPath: ['00 - Documentacion Personal'] },
  'g2-doc-financiera': { titulo: 'Doc. Financiera - Bancos - Billeteras', startPath: ['03 - Doc. Financiera - Bancos - Billeteras'] },
  'g2-informes': { titulo: 'Informes', startPath: ['04 - Informes'] },
  'g2-recepcion': { titulo: 'Recepcion de Documentacion', startPath: ['05 - Recepcion De Documentacion'] },
  'g2-proveedor': { titulo: 'Proveedor del Estado', startPath: ['06 - Proveedor Del Estado'] },
};

export const FOLDER_KEYS = Object.keys(FOLDER_ROUTES);

export function detectarTabKey(folderPath) {
  if (!folderPath || folderPath.length === 0) return null;
  const pathStr = folderPath.map(p => (p.nombre || '').toLowerCase()).join('/');
  for (const [tabKey, route] of Object.entries(FOLDER_ROUTES)) {
    const routeStr = route.startPath.map(n => n.toLowerCase()).join('/');
    if (pathStr.includes(routeStr)) return tabKey;
  }
  return null;
}
